<ng-container *ngIf="showNavigation">
    <ng-container *ngIf="!(pmcId$ | async) && !(orgId$ | async)">
        <a mat-fab extended disableRipple sidenavNavigationItem
           animated [fadeFrom]="'top'" [delayed]="'list'"
           description="{{ 'App dashboard' }}"
           [routerLink]="['/app', 'organization', 'dashboard']"
           [routerLinkActive]="['mat-button-active']">
            <mat-icon [svgIcon]="'v2:fi-br-chart-mixed'"></mat-icon>
            <span [innerHTML]="'Admin Dashboard'"></span>
        </a>
    </ng-container>

    <ng-container *ngIf="(pmcId$ | async) as pmcId">
        <a *ngIf="showPmcLaunchpad"
           mat-fab extended disableRipple sidenavNavigationItem
           animated [fadeFrom]="'top'" [delayed]="'list'"
           description="{{ 'Getting started with managed properties' }}"
           [routerLink]="['/pmc', pmcId, 'launchpad']"
           [routerLinkActive]="['mat-button-active']">
            <mat-icon [svgIcon]="'v2:fi-br-launchpad'"></mat-icon>
            <span [innerHTML]="'Launchpad'"></span>
        </a>

        <a mat-fab extended disableRipple sidenavNavigationItem
           animated [fadeFrom]="'top'" [delayed]="'list'"
           description="{{ 'Property management dashboard' }}"
           [routerLink]="['/pmc', pmcId, 'dashboard']"
           [routerLinkActive]="['mat-button-active']">
            <mat-icon [svgIcon]="'v2:fi-br-chart-mixed'"></mat-icon>
            <span [innerHTML]="'Dashboard'"></span>
        </a>

        <a mat-fab extended disableRipple sidenavNavigationItem
           animated [fadeFrom]="'top'" [delayed]="'list'"
           description="{{ 'Communities under managed properties' }}"
           [routerLink]="['/pmc', pmcId, 'communities']"
           [routerLinkActive]="['mat-button-active']">
            <mat-icon [svgIcon]="'v2:fi-br-building'"></mat-icon>
            <span [innerHTML]="'Communities'"></span>
        </a>

        <a mat-fab extended disableRipple sidenavNavigationItem
           animated [fadeFrom]="'top'" [delayed]="'list'"
           description="{{ 'Team under managed properties' }}"
           [routerLink]="['/pmc', pmcId, 'team']"
           [routerLinkActive]="['mat-button-active']">
            <mat-icon [svgIcon]="'v2:fi-br-team'"></mat-icon>
            <span [innerHTML]="'Team'"></span>
        </a>

        <a mat-fab extended disableRipple sidenavNavigationItem
           animated [fadeFrom]="'top'" [delayed]="'list'"
           description="{{ 'Requests from managed properties' }}"
           [routerLink]="['/pmc', pmcId, 'requests']"
           [routerLinkActive]="['mat-button-active']">
            <mat-icon [svgIcon]="'v2:fi-br-question'"></mat-icon>
            <span [innerHTML]="'Requests'"></span>
        </a>

        <a mat-fab extended disableRipple sidenavNavigationItem
           animated [fadeFrom]="'top'" [delayed]="'list'"
           description="{{ 'Violations from managed properties' }}"
           [routerLink]="['/pmc', pmcId, 'violations']"
           [queryParams]="{ state: 'pending' }"
           [routerLinkActive]="['mat-button-active']">
            <mat-icon [svgIcon]="'v2:fi-br-triangle-warning'"></mat-icon>
            <span [innerHTML]="'Violations'"></span>
        </a>

        <a *superAccess mat-fab extended disableRipple sidenavNavigationItem
           animated [fadeFrom]="'top'" [delayed]="'list'"
           description="{{ 'Feature flags for managed properties' }}"
           [routerLink]="['/pmc', pmcId, 'feature-flags']"
           [routerLinkActive]="['mat-button-active']">
            <mat-icon [svgIcon]="'v2:fi-br-flag'"></mat-icon>
            <span [innerHTML]="'Feature Flags'"></span>
        </a>
    </ng-container>

    <a *superAccess mat-fab extended disableRipple sidenavNavigationItem
       animated [fadeFrom]="'top'" [delayed]="'list'"
       description="{{ 'Managed properties list' }}"
       [routerLink]="['/pmc', 'list']"
       [routerLinkActive]="['mat-button-active']">
        <mat-icon [svgIcon]="'v2:fi-br-company'"></mat-icon>
        <span [innerHTML]="'Companies'"></span>
    </a>

    <ng-container *ngIf="(orgId$ | async) as orgId">
        COMING SOON
    </ng-container>
</ng-container>

<sidenav-navigation-loading *ngIf="!showNavigation" animated delayed></sidenav-navigation-loading>
